import { render } from "./Update.vue?vue&type=template&id=1e62bb46"
import script from "./Update.vue?vue&type=script&lang=js"
export * from "./Update.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Update.vue"]])

export default __exports__